import { useCallback, useMemo, useState, type ReactNode } from "react"

import { BreadcrumbContext } from "@/app/layouts/breadcrumb-context"

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [overrides, setOverrides] = useState<Record<string, string>>({})

  const definir = useCallback((path: string, label: string) => {
    setOverrides((atual) => (atual[path] === label ? atual : { ...atual, [path]: label }))
  }, [])

  const limpar = useCallback((path: string) => {
    setOverrides((atual) => {
      if (!(path in atual)) return atual
      const copia = { ...atual }
      delete copia[path]
      return copia
    })
  }, [])

  const value = useMemo(
    () => ({ overrides, definir, limpar }),
    [overrides, definir, limpar],
  )

  return <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>
}
